<script setup lang="ts">
import { NxtIcon } from '@future-harry/nxt-styles';

const props = defineProps({
   data: {
      type: Object,
      default: () => ({}),
   },
});
</script>

<template>
   <div class="image-content">
      <a v-if="props.data.url" :href="props.data.url" target="_blank">
         <img v-if="props.data.image?.url" :src="props.data.image.url" />
         <div v-else class="image-content__placeholder">
            <NxtIcon name="image" size="large" />
         </div>
      </a>
      <div v-else>
         <img v-if="props.data.image?.url" :src="props.data.image.url" />
         <div v-else class="image-content__placeholder">
            <NxtIcon name="image" size="large" />
         </div>
      </div>
   </div>
</template>

<style scoped lang="scss">
.image-content {
   display: flex;
   margin: 0 auto;
   max-width: 1000px;
   align-items: center;
   text-align: center;
   justify-content: center;

   img {
      max-width: 100%;
      object-fit: cover;
   }

   > div {
      width: 100%;
   }

   &__placeholder {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      background: var(--nxt-light-grey);
      min-height: 200px;
   }
}
</style>
